import { Component, inject } from '@angular/core';
import { User } from 'api-clients/identity-server-api-client';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'acord-eula-modal',
  templateUrl: './acord-eula-modal.component.html',
  styleUrls: ['./acord-eula-modal.component.scss'],
  standalone: false,
})
export class AcordEulaModalComponent {
  user: User;

  readonly #userService = inject(UserService);

  constructor() {
    this.user = this.#userService.user;
  }
}
